module.exports = __webpack_public_path__ + "img/logo.66865925.png";